import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { VideosHttpResult } from '../models/video.model';

@Injectable({
  providedIn: 'root'
})
export class FavoritesApi {
  constructor(private readonly http: HttpClient) { }

  getMyFavoritesVideos(page: number, limit: number): Observable<VideosHttpResult> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('withoutCoaching', false);
    return this.http.get<VideosHttpResult>(environment.api.dashboard.myFavorites, { params });
  }
}
